/**
 * Brand wordmark: GIERMEK with a half-sized .online suffix.
 *
 * Letter-spacing is declared by call sites as `--brand-tracking` (e.g. `[--brand-tracking:0.4em]`)
 * rather than as a Tailwind class, so that the single value both spaces the main part and cancels
 * the gap that trailing letter-spacing leaves before the suffix. The factor of two accounts for
 * the suffix being half the size, so the compensation resolves against the same font-size as the
 * gap it cancels.
 */

interface BrandNameProps {
  /** Additional CSS classes, typically size, weight and colour of the main part */
  className?: string
}

export function BrandName({ className = '' }: BrandNameProps) {
  return (
    <span
      className={`whitespace-nowrap ${className}`}
      style={{ letterSpacing: 'var(--brand-tracking, normal)' }}
    >
      GIERMEK
      {/* `em` keeps the suffix at half the main part regardless of the inherited size;
          `lowercase` guards against an `uppercase` ancestor. */}
      <span
        className="text-[0.5em] lowercase tracking-normal"
        style={{ marginLeft: 'calc(-2 * var(--brand-tracking, 0em))' }}
      >
        .online
      </span>
    </span>
  )
}
